import React, { useState, useEffect } from 'react';

import { useNavigate } from 'react-router-dom'
import logo from '../assets/logotipo.png'
import background from '../assets/background_frutas.png'
import TextField from '@mui/material/TextField';
import Alert from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';
import { login } from '../service/api';

import './Login.scss';

const Login = () => {
    let navigate = useNavigate()
    const [email, setEmail] = useState("")
    const [password, setPassword] = useState("")
    const [open, setOpen] = useState(false)
    const [userId, setUserId] = useState("")
    const [errorMessage, setErrorMessage] = useState("")

    React.useEffect(() => {
        const userId = localStorage.getItem('userId')
        if (userId) {
            navigate('/', { replace: true })
        }
    })

    const onClickLogin = async (path) => {
        console.log('click')
        console.log(email)

        await login(email, password)
            .then(response => {
                console.log(response)
                if(response){   
                    localStorage.setItem("userId", response.userId)
                    navigate(path, { replace: true })
                }
            })
            .catch(function (error) {
                console.log(error)
                setErrorMessage(error)
                setOpen(true)
            });

    }

    const onClickCadastro = (path) => {
        navigate(path, { replace: true })
    }

    const handleChange = (value, state) => {
        state(value)
    }

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setOpen(false);
    };

    return (
        <div className='login'>
            <div className='login__header'>
                <img src={logo} alt='' className='login__logo' />
            </div>

            <div className='login__formEmail'>
                <TextField fullWidth onChange={(event) => handleChange(event.target.value, setEmail)} id="outlined-basic" label="Email" variant="outlined" className='login__emailField' />
            </div>

            <div className='login__formPass'>
                <TextField fullWidth onChange={(event) => handleChange(event.target.value, setPassword)} id="outlined-password-input" label="Senha" variant="outlined" className='login__passField' type="password" autoComplete="current-password" />
            </div>

            <div style={{ width: '100vw' }}>
                <div className='login__cardLogin' onClick={() => onClickLogin(`/`)}>
                    Entrar
                </div>
            </div>

            <div style={{ width: '100vw' }}>
                <div className='login__cardSignup' onClick={() => onClickCadastro(`/cadastro`)}>
                    Criar conta
                </div>
            </div>

            <Snackbar open={open} autoHideDuration={6000} onClose={handleClose} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
                <Alert onClose={handleClose} severity="error" sx={{ width: '100%' }}>{errorMessage}</Alert>
            </Snackbar>

            <div className='login__background'>
                <img src={background} alt='' className='login__backgroundImage' />
            </div>

        </div>
    )
}

export default Login